import React, { useState, useEffect, useCallback } from "react";
import Layout from "../../Components/Layout";
import FilterSidebar from "./Filterbar";
import DataTable from "./DataTable";
import { Categories } from "./Categories";
import { patientService } from "../../services/patientService";

const StatisticsPage: React.FC = () => {
  const [filters, setFilters] = useState<Record<string, any>>({});
  const [allPatients, setAllPatients] = useState<any[]>([]);
  const [tablePatients, setTablePatients] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await patientService.getAll(filters);
        const dataList = response || [];
        setAllPatients(dataList);
        setTablePatients(dataList);
      } catch (error) {
        console.error("Error fetching patients:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [filters]);

  const handleFilteredPatientsChange = useCallback((filtered: any[]) => {
    setTablePatients(filtered);
  }, []);

  return (
    <Layout>
      <div className="flex flex-col h-full">
        <div className="flex flex-1 overflow-hidden">
          <FilterSidebar onFilterChange={setFilters} />

          <div className="flex-1 p-6 overflow-auto flex flex-col gap-6">
            <h2 className="text-xl font-bold text-gray-800">
              Στατιστικά Στοιχεία & Αναλύσεις Ασθενών
            </h2>

            {/* Νέο Component που συνδέει τα Hooks με το PieChart */}
            <Categories
              patients={allPatients}
              activeFilters={filters}
              loadingPatients={loading}
              onFilteredPatientsChange={handleFilteredPatientsChange}
            />

            <div className="bg-white p-6 rounded-lg shadow-sm flex flex-col gap-4">
              <DataTable
                data={tablePatients}
                loading={loading}
                onRowClick={(p) => window.open(`/patients/${p.id}`, "_blank")}
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default StatisticsPage;